import { useQuery, gql } from '@apollo/client';

export const mainDirectoryEntryWizardsQuery = gql`
    query DirectoryWizards($entryID: ID!) {
        allMainDirectoryEntryWizards(entryID: $entryID) {
            showCheckInOut
            showAddNote
            recentItems {
                id
                description
                table
                methodName
                successMessage
                reloadCurrentScreen
                hasUI
                suppressUIAndConfirmation
                showWizardReportWhenComplete
                persistStepData
                persistBackwards
                executeAll
                hasReviewStep
                confirmationMessage
                delayEnableCheckUntilExecution
            }
        }
    }
`;

export type CheckInOut = 'SHOW_CHECK_IN' | 'SHOW_CHECK_OUT' | 'NONE';

export interface IRecentItemsNode {
    id: string;
    description: string;
    table: string;
    methodName: string;
    successMessage: string;
    reloadCurrentScreen: boolean;
    hasUI: boolean;
    suppressUIAndConfirmation: boolean;
    showWizardReportWhenComplete: boolean;
    persistStepData: boolean;
    persistBackwards: boolean;
    executeAll: boolean;
    hasReviewStep: boolean;
    confirmationMessage: string;
    delayEnableCheckUntilExecution: boolean;
}

export interface IMainDirectoryEntryWizardsQueryResult {
    allMainDirectoryEntryWizards: {
        showCheckInOut: CheckInOut;
        showAddNote: boolean;
        recentItems: IRecentItemsNode[];
    };
}

interface IMainDirectoryEntryWizardsQueryVars {
    entryID: string;
}

export const useMainDirectoryEntryWizardsQuery = (variables: IMainDirectoryEntryWizardsQueryVars) =>
    useQuery<IMainDirectoryEntryWizardsQueryResult, IMainDirectoryEntryWizardsQueryVars>(mainDirectoryEntryWizardsQuery, {
        variables,
        fetchPolicy: 'network-only',
    });
